/* eslint-disable no-use-before-define */
import React from 'react'
import { ChartCaption } from './chart-caption'
import { ChartFigure } from './chart-figure'

export const Chart = ({chartData, bondInfo}) =>
    <React.Fragment>
        <div className="row vertical-offset-sm">
        <div className="col-md-12 col-xs-12">
        {Array.isArray(chartData) &&
            <figure>
            <div aria-hidden="true" style={{fontSize:'12px'}}>
                <ChartFigure chartData={chartData} bondInfo={bondInfo} />
            </div>
            <figcaption className="screen-reader-only">
                <ChartCaption chartData={chartData} bondInfo={bondInfo} />
            </figcaption>
            </figure>
        }
        </div>
        </div>
    </React.Fragment>



// WEBPACK FOOTER //
// ./src/calculator/calc-output/chart.js